import { environment } from "../../environments/environment";

export const DEFAULT_LISTING_IMAGE = 'assets/images/scribble-list.svg';

export const CLOUD_IMAGE_URL = `https://${environment.cloudImage.key}.${environment.cloudImage.url}`;